import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const PinterestOutlined24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.pinterestFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm0 1.198C6.815 2.198 2.198 6.815 2.198 12.5S6.815 22.802 12.5 22.802 22.802 18.185 22.802 12.5 18.185 2.198 12.5 2.198zm-2.49 5.634s1.99-1.439 4.7-.444c0 0 2.472.818 2.69 3.7.222 2.883-1.502 4.284-1.502 4.284s-1.515 1.462-3.26.693c0 0-.472-.172-.794-.708l-.55 2.213s-.237.9-1.22 2.193c0 0-.093.118-.172 0 0 0-.09-.552-.107-1.102a7.033 7.033 0 01.193-2.011l.846-3.696.01-.007c-.096-.154-.329-.63-.198-1.61 0 0 .159-1.156.966-1.386.806-.23 1.279.24 1.32.923.043.685-.402 1.899-.402 1.899l-.164.588-.074.306s-.195.882.695 1.27c0 0 .772.35 1.587-.419 0 0 .65-.664.913-1.753 0 0 .7-2.522-.621-3.706-1.322-1.183-3.143-.705-3.742-.404-.599.307-1.801 1.133-1.905 3.129 0 0-.028.761.383 1.37l.154.189s.086.1.064.194l-.183.749s-.074.24-.3.169c0 0-1.148-.29-1.442-2.058 0 0-.612-2.773 2.115-4.565z"
      fillRule="evenodd"
    />
  </svg>
);

export default PinterestOutlined24;
